
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import { useStore } from '@/store'
import networkConfig from '@/config/default/net.config'
import { Route } from '@/constant/route'
import {
  LabelIconModel,
  LabelIconPageSearchModel,
  LabelIconSearchModel,
  LabelIconAddModel,
  LabelIconUpdateModel,
  IdsModel
} from '@/model/product/LabelIconModel'
import {
  pageSearchLabelIcon,
  // addLabelIcon,
  updateLabelIcon,
  removeLabelIcon,
  batchRemoveLabelIcon
} from '@/apis/product/labelIcon'
import { LabelIconCategorySearchModel } from '@/model/product/LabelIconCategoryModel'
import { searchLabelIconCategory } from '@/apis/product/labelIconCategory'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    UploadFormItem,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const updateUpload = ref()
    const createUpload = ref()
    const searchStruct = [
      {
        prop: 'categoryId',
        label: t('labelIcon.categoryId'),
        placeholder: t('labelIcon.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const createStruct = [
      // { prop: 'iconThumbnail', label: t('labelIcon.iconThumbnail'), placeholder: t('labelIcon.iconThumbnailP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'categoryId',
        label: t('labelIcon.categoryId'),
        placeholder: t('labelIcon.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const updateStruct = [
      // { prop: 'iconThumbnail', label: t('labelIcon.iconThumbnail'), placeholder: t('labelIcon.iconThumbnailP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'categoryId',
        label: t('labelIcon.categoryId'),
        placeholder: t('labelIcon.categoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const labelIconRole = {
      // iconThumbnail: [{ required: true, message: t('labelIcon.iconThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      iconThumbnail: [{ validator: () => createUpload.value ? !createUpload.value.validateUpload() : false, message: t('labelIcon.iconThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      categoryId: [{ required: true, message: t('labelIcon.categoryId').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'imageUrl', label: t('labelIcon.imageUrl'), sortable: 'custom', link: true },
      { prop: 'iconThumbnail', label: t('labelIcon.iconThumbnail'), sortable: 'custom', img: 'imageUrl' },
      { prop: 'categoryName', label: t('labelIcon.categoryId'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: LabelIconModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: LabelIconModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as LabelIconSearchModel,
      tableData: Array<LabelIconModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'labelIcon.edit',
        create: 'labelIcon.create'
      },
      dialogFormVisible: false,
      labelIconRole: labelIconRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as LabelIconAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as LabelIconUpdateModel,
      editRow: {} as LabelIconModel,
      loadingUpload: null as any,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: LabelIconPageSearchModel = {
          imageUrl: dataMap.searchFormModel.imageUrl,
          iconThumbnail: dataMap.searchFormModel.iconThumbnail,
          categoryId: dataMap.searchFormModel.categoryId,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchLabelIcon(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        if (createUpload.value.validateUpload()) {
          return
        }
        dataMap.loadingUpload = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        await createUpload.value.submitUpload()
      },
      async updateSubmit() {
        const updateData: LabelIconUpdateModel = {
          id: dataMap.updateModel.id,
          categoryId: dataMap.updateModel.categoryId
        }
        const result = await updateLabelIcon(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeLabelIcon(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveLabelIcon(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.categoryId = dataMap.editRow.categoryId
        if (updateUpload.value) {
          updateUpload.value.onReset()
        }
      },
      createReset() {
        console.log('create reset')
        if (createUpload.value) {
          createUpload.value.onReset()
        }
      }
    })
    const getLabelIconCategoryOptions = async(query: string) => {
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].loading = true
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].loading = true
        }
      } else {
        dataMap.searchFormStruct[0].loading = true
      }
      const params: LabelIconCategorySearchModel = {
        categoryName: query,
        categoryOrder: null
      }
      const data = await searchLabelIconCategory(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.categoryName, value: iterator.id })
      }
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].options = optionList
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].options = optionList
        }
      } else {
        dataMap.searchFormStruct[0].options = optionList
      }
      dataMap.createStruct[0].loading = false
      dataMap.updateStruct[0].loading = false
      dataMap.searchFormStruct[0].loading = false
    }
    const handleCreate = () => {
      dataMap.createReset()
      dataMap.dialogStatus = 'create'
      getLabelIconCategoryOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: LabelIconModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.categoryId = row.categoryId
        getLabelIconCategoryOptions('')
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      dataMap.dialogFormVisible = false
      dataMap.getList()

      ElMessage({
        message: t('common.createSuccess'),
        type: 'success',
        duration: 2000
      })
    }
    const getUploadUri = () => {
      return networkConfig.host + Route.product + '/labelIcon/add'
    }
    const getUploadHeader = () => {
      return {
        Authorization: 'Bearer ' + useStore().state.user.token
      }
    }
    onMounted(() => {
      dataMap.searchFormStruct[0].remoteMethod = getLabelIconCategoryOptions
      dataMap.createStruct[0].remoteMethod = getLabelIconCategoryOptions
      dataMap.updateStruct[0].remoteMethod = getLabelIconCategoryOptions
      getLabelIconCategoryOptions('')
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      getUploadUri,
      getUploadHeader,
      handleUpload,
      updateUpload,
      createUpload,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
